import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["routerConfiguration"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _ from '@sparta.global.vendors/lodash';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es5.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es5.js';
import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es5.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es5.js';
import spartaGlobalFunctions from '@sparta.global.utilities/sparta-global-functions-utility/dist/es5.js';
import spartaContentManagerUtility from '@sparta.global.utilities/sparta-content-manager-utility/dist/es5.js';
import '@sparta.global.utilities/sparta-browser-support-utility/dist/es5.js';

// Third party imports

// Constants

console.log("####################### sparta-bootstrap-utility loaded ##################");
var EVENTS = {
  SPARTA_GLOBAL_READY: "SPARTA_GLOBAL_READY.spartaBootstrapUtility",
  SPARTA_SECONDARY_READY: "SPARTA_SECONDARY_READY.spartaBootstrapUtility",
  SPARTA_WINDOW_SCROLL: "SPARTA_WINDOW_SCROLL.spartaBootstrapUtility"
};
function publishGlobalReadyEvents(loop, events, widgetInfo) {
  if (loop.total === 1) {
    spartaEventsUtility.pub(events.SPARTA_GLOBAL_READY, null, widgetInfo);
  }
  if (loop.total === 2) {
    if (loop.completed === 0) {
      spartaEventsUtility.pub(events.SPARTA_GLOBAL_READY, null, widgetInfo);
    } else if (loop.completed > 0) {
      spartaEventsUtility.pub(events.SPARTA_SECONDARY_READY, null, widgetInfo);
    }
  }
}
var SpartaBootstrapUtility = /*#__PURE__*/function () {
  function SpartaBootstrapUtility() {
    var _this = this;
    _classCallCheck(this, SpartaBootstrapUtility);
    /**
     * Asynchronous function to dynamically import Vue package only when needed
     * @returns {object} Vue package export
     */
    _defineProperty(this, "getVue", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var vueImport;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.vue === undefined)) {
              _context.next = 13;
              break;
            }
            vueImport = _.find(_this.spaParams.dynamicImportMap.modules, function (module) {
              return module.name === '@sparta.global.vendors/vue';
            });
            if (!vueImport) {
              _context.next = 13;
              break;
            }
            if (!(_this.vueVersion === 2)) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return vueImport.loader();
          case 6:
            _context.t0 = _context.sent.default;
            _context.next = 12;
            break;
          case 9:
            _context.next = 11;
            return vueImport.loader();
          case 11:
            _context.t0 = _context.sent;
          case 12:
            _this.vue = _context.t0;
          case 13:
            return _context.abrupt("return", _this.vue);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    /**
     * Asynchronous function to dynamically import Vuex package only when needed
     * @returns {object} Vuex package export
     */
    _defineProperty(this, "getVuex", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var vuexImport, Vue;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(_this.vuex === undefined)) {
              _context2.next = 11;
              break;
            }
            vuexImport = _.find(_this.spaParams.dynamicImportMap.modules, function (module) {
              return module.name === '@sparta.global.vendors/vuex';
            });
            if (!vuexImport) {
              _context2.next = 11;
              break;
            }
            _context2.next = 5;
            return vuexImport.loader();
          case 5:
            _this.vuex = _context2.sent;
            if (!(_this.vueVersion === 2)) {
              _context2.next = 11;
              break;
            }
            _context2.next = 9;
            return _this.getVue();
          case 9:
            Vue = _context2.sent;
            Vue.use(_this.vuex);
          case 11:
            return _context2.abrupt("return", _this.vuex);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    /**
     * Asynchronous function to return the Vuex master store
     * @returns {object} Vuex store object
     */
    _defineProperty(this, "getVuexStore", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var Vuex;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_this.vuexStore === undefined)) {
              _context3.next = 5;
              break;
            }
            _context3.next = 3;
            return _this.getVuex();
          case 3:
            Vuex = _context3.sent;
            _this.vuexStore = _this.vueVersion === 2 ? new Vuex.Store() : Vuex.createStore({});
          case 5:
            return _context3.abrupt("return", _this.vuexStore);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    this.modulesLoaded = {};
    this.modules = [];
    this.initedModules = [];
    this.moduleInstances = [];
    this.appContainer = null;
    this.browser = spartaStoreUtility.getData("browser");
    this.loop = {
      total: 1,
      completed: 0
    };
  }
  return _createClass(SpartaBootstrapUtility, [{
    key: "EVENTS",
    get: function get() {
      return EVENTS;
    }

    /**
     * Registers the shared component
     * @param {Array} sharedComponents The shared components listed in the dynamic import map
     * @param {int} vueVersion The Vue major version being used
     */
  }, {
    key: "registerSharedComponents",
    value: (function () {
      var _registerSharedComponents = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sharedComponents) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return Promise.all(sharedComponents.map(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(comp) {
                  var loadedComponent, componentName;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return comp.loader();
                      case 2:
                        loadedComponent = _context4.sent;
                        componentName = loadedComponent.default ? loadedComponent.default.name : loadedComponent.name; // ToDo: Will revisit this later when we a strategy to handle multi exported components from a single package
                        // if (!componentName) {
                        //   console.warn(`SpartaBootstrapUtility:: Component "${comp.name}" is missing "name" in its definition. It is a good practice to define the name for every Vue component which will help us identify any name conflicts on the page.`);
                        // } else {
                        //   (componentNameMap[componentName] = componentNameMap[componentName] || []).push(comp.name);
                        // }
                        if (!(_this2.vueVersion === 2)) {
                          _context4.next = 8;
                          break;
                        }
                        _context4.next = 7;
                        return _this2.getVue();
                      case 7:
                        if (componentName && _this2.vue) {
                          if (!_this2.vue.options.components[componentName]) {
                            _this2.vue.component(componentName, loadedComponent.default || loadedComponent);
                          }
                        }
                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function registerSharedComponents(_x) {
        return _registerSharedComponents.apply(this, arguments);
      }
      return registerSharedComponents;
    }()
    /**
     * Registers the store module and publishes the store event
     * @param {Array} stores The shared stores listed in the dynamic import map
     * @param {object} widgetInfo Object for the module widget
     */
    )
  }, {
    key: "registerPageStores",
    value: (function () {
      var _registerPageStores = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(stores, widgetInfo) {
        var _yield$Promise$all, _yield$Promise$all2, store, vuex, _iterator, _step, storeEntry, namespace, loader, loadedStore;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(stores.length > 0)) {
                _context6.next = 31;
                break;
              }
              _context6.next = 3;
              return Promise.all([this.getVuexStore(), this.getVuex()]);
            case 3:
              _yield$Promise$all = _context6.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              store = _yield$Promise$all2[0];
              vuex = _yield$Promise$all2[1];
              this.vuex = vuex;
              this.vuexStore = store;
              _iterator = _createForOfIteratorHelper(stores);
              _context6.prev = 10;
              _iterator.s();
            case 12:
              if ((_step = _iterator.n()).done) {
                _context6.next = 23;
                break;
              }
              storeEntry = _step.value;
              namespace = storeEntry.namespace, loader = storeEntry.loader;
              if (!(store.hasModule(namespace) === false)) {
                _context6.next = 21;
                break;
              }
              _context6.next = 18;
              return loader();
            case 18:
              loadedStore = _context6.sent;
              // Register store module and ensure it is namespaced
              store.registerModule(namespace, _objectSpread(_objectSpread({}, loadedStore.default), {}, {
                namespaced: true
              }));
              spartaEventsUtility.pub("".concat(namespace, "_STORE_INITIALIZED"), store, widgetInfo);
            case 21:
              _context6.next = 12;
              break;
            case 23:
              _context6.next = 28;
              break;
            case 25:
              _context6.prev = 25;
              _context6.t0 = _context6["catch"](10);
              _iterator.e(_context6.t0);
            case 28:
              _context6.prev = 28;
              _iterator.f();
              return _context6.finish(28);
            case 31:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[10, 25, 28, 31]]);
      }));
      function registerPageStores(_x3, _x4) {
        return _registerPageStores.apply(this, arguments);
      }
      return registerPageStores;
    }()
    /**
     * Asynchronous function to create and mount the Vue 3 app instance
     * @param {bbject} compDef The Vue component definition
     * @param {string} placeholder Placeholder where the app will be mounted
     * @param {object} nativeRouter Vue router object
     * @returns {object} Vue package export
     */
    )
  }, {
    key: "createAndMountApp",
    value: (function () {
      var _createAndMountApp = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(compDef, placeholder, nativeRouter) {
        var version, devtools, dynamicImport;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.getVue();
            case 2:
              this.app = this.vue.createApp(compDef);

              // turn Vue devtools on in Prod
              if (!this.spaParams.siteParams.isProd) {
                version = this.app.version;
                devtools = window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                if (devtools && version) {
                  devtools.enabled = true;
                  devtools.emit('app:init', this.app, version, {});
                }
              }
              dynamicImport = this.spaParams["dynamicImportMap"]; // Register shared components
              if (!(dynamicImport && dynamicImport.sharedComponents)) {
                _context7.next = 8;
                break;
              }
              _context7.next = 8;
              return this.registerSharedComponents(dynamicImport.sharedComponents);
            case 8:
              if (this.vuexStore) {
                this.app.use(this.vuexStore);
                this.app.vuexStore = this.vuexStore;
              }
              if (this.routerInstance) {
                this.app.use(this.routerInstance);
                this.app.router = this.routerInstance;
              }
              if (nativeRouter) {
                this.app.use(nativeRouter);
              }
              this.app.mount(placeholder);
              return _context7.abrupt("return", this.app);
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function createAndMountApp(_x5, _x6, _x7) {
        return _createAndMountApp.apply(this, arguments);
      }
      return createAndMountApp;
    }()
    /**
     * @param {object} widgetInfo
     * bootstrap kickoff
     */
    )
  }, {
    key: "init",
    value: (function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(widgetInfo) {
        var _this3 = this;
        var dynamicImport;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              console.log("init bootstrap");
              this.setApplicationData(widgetInfo);
              this.loadOptionsFromContainer(widgetInfo);
              this.checkForLangOverride(widgetInfo);
              this.spaParams = this.setupSpaParams(widgetInfo);
              this.setupGlobalEvents(widgetInfo);
              dynamicImport = this.spaParams["dynamicImportMap"];
              this.vueVersion = this.spaParams.siteParams.vueMajorVersion || 2;
              if (!dynamicImport) {
                _context9.next = 15;
                break;
              }
              if (!(dynamicImport.sharedComponents && this.vueVersion === 2)) {
                _context9.next = 12;
                break;
              }
              _context9.next = 12;
              return this.registerSharedComponents(dynamicImport.sharedComponents);
            case 12:
              if (!dynamicImport.stores) {
                _context9.next = 15;
                break;
              }
              _context9.next = 15;
              return this.registerPageStores(dynamicImport.stores, widgetInfo);
            case 15:
              _context9.next = 17;
              return this.createAndInitModules(widgetInfo).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var vueRouterImport;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      if (!(!_this3.spaParams.isSPA || _this3.spaParams.isSPA === 'false' || _this3.hasRouterConfig)) {
                        _context8.next = 4;
                        break;
                      }
                      publishGlobalReadyEvents(_this3.loop, _this3.EVENTS, widgetInfo);
                      _context8.next = 21;
                      break;
                    case 4:
                      vueRouterImport = _.find(dynamicImport.modules, function (module) {
                        return module.name === '@sparta.global.vendors/vue-router';
                      });
                      if (!vueRouterImport) {
                        _context8.next = 20;
                        break;
                      }
                      if (!(_this3.vueVersion === 2)) {
                        _context8.next = 12;
                        break;
                      }
                      _context8.next = 9;
                      return vueRouterImport.loader();
                    case 9:
                      _context8.t0 = _context8.sent.default;
                      _context8.next = 15;
                      break;
                    case 12:
                      _context8.next = 14;
                      return vueRouterImport.loader();
                    case 14:
                      _context8.t0 = _context8.sent;
                    case 15:
                      _this3.VueRouter = _context8.t0;
                      if (!(_this3.vueVersion === 2)) {
                        _context8.next = 20;
                        break;
                      }
                      _context8.next = 19;
                      return _this3.getVue();
                    case 19:
                      _this3.vue.use(_this3.VueRouter);
                    case 20:
                      _this3.initializeRouter(widgetInfo).then(function () {
                        return publishGlobalReadyEvents(_this3.loop, _this3.EVENTS, widgetInfo);
                      });
                    case 21:
                      _this3.addPreventDefaultForLinks(document);
                    case 22:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              })))
              // Ready sparta content manager
              .then(function () {
                _this3.initContentManagerUtility(widgetInfo);
              });
            case 17:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function init(_x8) {
        return _init.apply(this, arguments);
      }
      return init;
    }())
  }, {
    key: "setLoop",
    value: function setLoop(loopObj) {
      this.loop = loopObj;
    }
  }, {
    key: "isWidget",
    value: function isWidget(widgetInfo) {
      return widgetInfo && widgetInfo.name && widgetInfo.version;
    }
  }, {
    key: "setupSpaParams",
    value: function setupSpaParams(widgetInfo) {
      var httpRegExp = new RegExp('^http(s?)\:', 'i');
      var isWidget = this.isWidget(widgetInfo);
      var spaParams = isWidget ? window.spaWidgetParams[widgetInfo.name][widgetInfo.version][widgetInfo.id] : window.spaParams;
      var protocol = spaParams.siteParams.domain.ssl ? 'https://' : 'http://';
      var isHttpURL = '';
      if (isWidget) {
        spaParams.isWidget = true;
        isHttpURL = httpRegExp.test(spaParams.siteParams.widgetAPIEndpoint);
        spaParams.siteParams.widgetAPIEndpoint = spaParams.siteParams.widgetAPIEndpoint || widgetInfo.widgetAPIEndpoint;
        if (!isHttpURL) {
          spaParams.siteParams.widgetAPIEndpoint = protocol + spaParams.siteParams.widgetAPIEndpoint;
        }
      } else {
        isHttpURL = httpRegExp.test(spaParams.siteParams.domain.hostname);
        if (!isHttpURL) {
          spaParams.siteParams.domain.hostname = protocol + spaParams.siteParams.domain.hostname;
        }
      }

      // set siteParams on spaParams if loading as a widget
      spaParams.siteParams = spaParams.siteParams || spaParams.params;
      var lang = isWidget ? spartaStoreUtility.getData("lang").split("-")[0] : sparta.language;
      var language = lang || "en";
      spaParams.language = language;
      spartaStoreUtility.addData("spaParams", spaParams);

      // update bank holidays based on the current language
      var bankHolidays = spaParams.global[spaParams.language] ? spaParams.global[spaParams.language].bankHolidays : null;
      if (bankHolidays) {
        spartaStoreUtility.addData("bankHolidays", bankHolidays);
      }
      spartaEventsUtility.pub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, spaParams);
      return spaParams;
    }
  }, {
    key: "setApplicationData",
    value: function setApplicationData(widgetInfo) {
      var appContainer;
      var mediaQueryContainer;
      var isWidget = this.isWidget(widgetInfo);
      spartaStoreUtility.addData("isWidget", isWidget); //Do not pass widgetInfo here because its not required for this flag

      if (isWidget) {
        appContainer = document.querySelector("#".concat(widgetInfo.id, " [data-sparta-container]"));
        if (!appContainer) {
          throw new Error("Widget container not found on the page: ".concat(JSON.stringify(widgetInfo)));
        }
        mediaQueryContainer = appContainer.parentElement;
        spartaStoreUtility.addData("applicationContext", widgetInfo, true, widgetInfo);
      } else {
        // Sparta page loaded through Wealth Sparta Page Handler which injects mlGlobalData object containing csrfToken
        if (sparta.mlGlobalData) {
          spartaStoreUtility.addData("csrfToken", sparta.mlGlobalData.csrfToken);
        }
      }
      spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTEXT_LOADED, spartaStoreUtility.getData("applicationContext", widgetInfo), widgetInfo);
      if (!appContainer) {
        // only for Sparta sites
        var topContainer = document.querySelectorAll("[data-sparta-container]");
        mediaQueryContainer = document.querySelector("[data-sparta-wrapper]");
        if (!topContainer.length) {
          throw new Error("Unable to find a sparta container on the page");
        }
        topContainer = _toConsumableArray(topContainer).filter(function (el) {
          return !el.classList.contains("sparta-widget-container");
        });
        if (topContainer.length !== 1) {
          throw new Error("too many containers on page, must use widget configuration or loader");
        }
        var _topContainer = topContainer;
        var _topContainer2 = _slicedToArray(_topContainer, 1);
        appContainer = _topContainer2[0];
      }
      this.appContainer = appContainer;
      spartaMediaQueryUtility.init(mediaQueryContainer || appContainer);
      spartaStoreUtility.addData("applicationContainer", appContainer, true, widgetInfo);
      spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTAINER_LOADED, appContainer, widgetInfo);
    }

    /**
     * Loads application options/overrides into store from
     * appContainer.attr('data-sparta-overrides')
     */
  }, {
    key: "loadOptionsFromContainer",
    value: function loadOptionsFromContainer(widgetInfo) {
      var appContainer = spartaStoreUtility.getData("applicationContainer", widgetInfo);
      var containers = [].slice.call(Array.isArray(appContainer) ? appContainer : [appContainer]);
      var optionsObj = JSON.parse(containers[containers.length - 1].getAttribute("data-sparta-options")) || {};
      spartaStoreUtility.addData("applicationOptions", optionsObj, true, widgetInfo);
    }

    /**
     * Checks the application container if there is a language override.
     */
  }, {
    key: "checkForLangOverride",
    value: function checkForLangOverride(widgetInfo) {
      var containers = spartaStoreUtility.getData("applicationContainer", widgetInfo);
      var appContainer = [].slice.call(Array.isArray(containers) ? containers : [containers]);
      var langOverride = appContainer && appContainer[appContainer.length - 1].getAttribute("data-sparta-lang") || null;
      if (langOverride) {
        spartaStoreUtility.addData("lang", langOverride.toLowerCase());
      }
    }

    /**
     * instantiate page modules
     */
  }, {
    key: "createModuleInstances",
    value: (function () {
      var _createModuleInstances = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(widgetInfo) {
        var containers, applicationContainer, boaModules, widgetModules, _iterator2, _step2, moduleDom, className, options, _this$modulesLoaded$c, moduleClass, moduleConfig, _moduleConfig$stores, stores, _moduleConfig$type, type, store, _iterator3, _step3, storeEntry, namespace, loader, loadedStore, _yield$Promise$all3, _yield$Promise$all4;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              containers = spartaStoreUtility.getData("applicationContainer", widgetInfo);
              applicationContainer = Array.isArray(containers) ? containers[containers.length - 1] : containers;
              boaModules = this._getUninitializedModules(_toConsumableArray(applicationContainer.querySelectorAll('[data-component="module"]'))); // Added temporary fix to prevent widget modules to corrupt non widget modules rendering.
              // TODO: Revists once again after adding wiget modules identification from Sparta platform
              // and remove it if widgetInfo is empty.
              if (_.isEmpty(widgetInfo)) {
                widgetModules = applicationContainer.querySelectorAll('.sparta-widget-container [data-component="module"]');
                _.remove(boaModules, function (boaModule) {
                  return _.includes(widgetModules, boaModule);
                });
              }
              _iterator2 = _createForOfIteratorHelper(boaModules);
              _context10.prev = 5;
              _iterator2.s();
            case 7:
              if ((_step2 = _iterator2.n()).done) {
                _context10.next = 65;
                break;
              }
              moduleDom = _step2.value;
              className = moduleDom.getAttribute("data-init");
              if (!className) {
                _context10.next = 62;
                break;
              }
              // set default options to empty object if no options were provided
              options = JSON.parse(moduleDom.getAttribute("data-options")) || {};
              _this$modulesLoaded$c = this.modulesLoaded[className], moduleClass = _this$modulesLoaded$c.moduleClass, moduleConfig = _this$modulesLoaded$c.moduleConfig;
              _moduleConfig$stores = moduleConfig.stores, stores = _moduleConfig$stores === void 0 ? [] : _moduleConfig$stores, _moduleConfig$type = moduleConfig.type, type = _moduleConfig$type === void 0 ? null : _moduleConfig$type; // Load and register any store dependencies
              if (!(stores.length > 0)) {
                _context10.next = 43;
                break;
              }
              _context10.next = 17;
              return this.getVuexStore();
            case 17:
              store = _context10.sent;
              _context10.next = 20;
              return this.getVuex();
            case 20:
              options.vuex = _context10.sent;
              options.vuexStore = store;
              _iterator3 = _createForOfIteratorHelper(stores);
              _context10.prev = 23;
              _iterator3.s();
            case 25:
              if ((_step3 = _iterator3.n()).done) {
                _context10.next = 35;
                break;
              }
              storeEntry = _step3.value;
              namespace = storeEntry.namespace, loader = storeEntry.loader;
              if (!(store.hasModule(namespace) === false)) {
                _context10.next = 33;
                break;
              }
              _context10.next = 31;
              return loader();
            case 31:
              loadedStore = _context10.sent;
              // Register store module and ensure it is namespaced
              store.registerModule(namespace, _objectSpread(_objectSpread({}, loadedStore.default), {}, {
                namespaced: true
              }));
            case 33:
              _context10.next = 25;
              break;
            case 35:
              _context10.next = 40;
              break;
            case 37:
              _context10.prev = 37;
              _context10.t0 = _context10["catch"](23);
              _iterator3.e(_context10.t0);
            case 40:
              _context10.prev = 40;
              _iterator3.f();
              return _context10.finish(40);
            case 43:
              // pass module Node reference as target to module initialization
              options.target = moduleDom;

              // create module instance
              if (!this.moduleInstances[className]) {
                this.moduleInstances[className] = [];
              }
              if (!(moduleClass !== undefined)) {
                _context10.next = 59;
                break;
              }
              options.widgetInfo = widgetInfo;

              // Add Vue, Vuex & VuexStore instances to each Vue module created
              if (!(type === 'vue')) {
                _context10.next = 55;
                break;
              }
              _context10.next = 50;
              return Promise.all([this.getVue(), this.getVuex(), this.getVuexStore()]);
            case 50:
              _yield$Promise$all3 = _context10.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 3);
              options.vue = _yield$Promise$all4[0];
              options.vuex = _yield$Promise$all4[1];
              options.vuexStore = _yield$Promise$all4[2];
            case 55:
              this.moduleInstances[className].push(new moduleClass(options));

              // we need to do this better, but goal is to remove this class after module initted
              // TODO maybe fire a custom event to hook into
              moduleDom.classList.remove("spa-module-init");
              _context10.next = 60;
              break;
            case 59:
              console.log("DID NOT FIND MODULE INSTANCE", className, this.moduleInstances);
            case 60:
              _context10.next = 63;
              break;
            case 62:
              console.log("className not found in DOM element", moduleDom);
            case 63:
              _context10.next = 7;
              break;
            case 65:
              _context10.next = 70;
              break;
            case 67:
              _context10.prev = 67;
              _context10.t1 = _context10["catch"](5);
              _iterator2.e(_context10.t1);
            case 70:
              _context10.prev = 70;
              _iterator2.f();
              return _context10.finish(70);
            case 73:
              spartaStoreUtility.addData("moduleInstances", this.moduleInstances);
            case 74:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[5, 67, 70, 73], [23, 37, 40, 43]]);
      }));
      function createModuleInstances(_x9) {
        return _createModuleInstances.apply(this, arguments);
      }
      return createModuleInstances;
    }()
    /**
     * Verify if there are modules with duplicate ids, rename the ids to make them unique
     * @param {object} module
     */
    )
  }, {
    key: "verifyUniqueModuleIds",
    value: function verifyUniqueModuleIds(module) {
      if (!module.settings.target || !module.settings.target.id) {
        return;
      }
      var moduleContainers = document.querySelectorAll("[id=\"".concat(module.settings.target.id, "\"]"));
      if (moduleContainers && moduleContainers.length > 1) {
        var imSettings,
          mSettings = module.settings;
        this.initedModules.reverse().every(function (im) {
          imSettings = im.module.settings;
          if (imSettings.moduleInfo && imSettings.moduleInfo.name === mSettings.moduleInfo.name && imSettings.target.id.startsWith(mSettings.target.id)) {
            // increment the total instances
            mSettings.target.totalInstances = (imSettings.target.totalInstances || 0) + 1;

            // keep the totalInstances only with the last instance
            delete imSettings.target.totalInstances;

            // rename the module container id
            mSettings.target.id = mSettings.target.id + mSettings.target.totalInstances;
            return false;
          }
          return true;
        });
      }
    }
  }, {
    key: "getExportName",
    value: function getExportName(module) {
      var exportName = module._spartaComponentConfig.export;
      if (typeof exportName === "string") {
        return exportName;
      }
      return exportName[0];
    }

    /**
     * call init functions of all instantiated page modules
     */
  }, {
    key: "initModules",
    value: (function () {
      var _initModules = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this4 = this;
        var dynamicImport, _iterator4, _step4, _loop;
        return _regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              console.log("### initModules");
              dynamicImport = this.dynamicImport || this.spaParams.dynamicImportMap;
              _iterator4 = _createForOfIteratorHelper(this.modules);
              _context12.prev = 3;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var module, vueRouterImport, componentDefinition, vueComponentDefinition, vueModulePlaceholder, _vueComponentDefiniti, routerConfiguration, vueComponentDefDetail, router, routerDetail, propType, _vueRouterImport, _this4$vue, h, resolveComponent, mergedComponentDefinition, vuexStore;
                return _regeneratorRuntime.wrap(function _loop$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      module = _step4.value;
                      if (!(module.state === "ready")) {
                        _context11.next = 60;
                        break;
                      }
                      _this4.verifyUniqueModuleIds(module.module);
                      if (_this4.routerInstance) {
                        module.module.router = _this4.routerInstance;
                      }
                      if (!(_this4.vueVersion === 3)) {
                        _context11.next = 13;
                        break;
                      }
                      vueRouterImport = _.find(dynamicImport.modules, function (module) {
                        return module.name === '@sparta.global.vendors/vue-router';
                      });
                      if (!vueRouterImport) {
                        _context11.next = 13;
                        break;
                      }
                      _context11.t0 = _this4.VueRouter;
                      if (_context11.t0) {
                        _context11.next = 12;
                        break;
                      }
                      _context11.next = 11;
                      return vueRouterImport.loader();
                    case 11:
                      _context11.t0 = _context11.sent;
                    case 12:
                      module.module.VueRouter = _context11.t0;
                    case 13:
                      componentDefinition = module.module.getVueComponentDefintion || module.module.componentDefinition;
                      if (componentDefinition) {
                        _context11.next = 17;
                        break;
                      }
                      _context11.next = 17;
                      return module.module[module.init](module.args);
                    case 17:
                      module.state = "initialized";
                      _this4.initedModules.push(module);
                      if (!componentDefinition) {
                        _context11.next = 60;
                        break;
                      }
                      vueComponentDefinition = componentDefinition.bind(module.module);
                      if (!vueComponentDefinition) {
                        _context11.next = 60;
                        break;
                      }
                      vueModulePlaceholder = document.createElement("div");
                      module.module.settings.target.appendChild(vueModulePlaceholder);
                      _vueComponentDefiniti = vueComponentDefinition(), routerConfiguration = _vueComponentDefiniti.routerConfiguration, vueComponentDefDetail = _objectWithoutProperties(_vueComponentDefiniti, _excluded);
                      if (!routerConfiguration) {
                        _context11.next = 47;
                        break;
                      }
                      if (vueComponentDefDetail.render || vueComponentDefDetail.template) {
                        propType = vueComponentDefDetail.render ? 'Render' : 'Template';
                        console.warn("".concat(propType, " property found in ").concat(module.module.constructor.name, " componentDefinition will be ignored."));
                      }
                      _this4.hasRouterConfig = true;
                      if (!(_this4.vueVersion === 3)) {
                        _context11.next = 33;
                        break;
                      }
                      _this4.VueRouter = module.module.VueRouter;
                      router = _this4.VueRouter.createRouter(routerConfiguration);
                      _context11.next = 43;
                      break;
                    case 33:
                      _vueRouterImport = _.find(dynamicImport.modules, function (module) {
                        return module.name === '@sparta.global.vendors/vue-router';
                      });
                      if (!_vueRouterImport) {
                        _context11.next = 43;
                        break;
                      }
                      _context11.t1 = _this4.VueRouter;
                      if (_context11.t1) {
                        _context11.next = 40;
                        break;
                      }
                      _context11.next = 39;
                      return _vueRouterImport.loader();
                    case 39:
                      _context11.t1 = _context11.sent.default;
                    case 40:
                      _this4.VueRouter = _context11.t1;
                      _this4.vue.use(_this4.VueRouter);
                      router = new _this4.VueRouter(routerConfiguration);
                    case 43:
                      if (_this4.vuexStore) {
                        _this4.vuexStore.$router = router;
                      }

                      // update meta title for routes
                      router.beforeEach(function (to, from, next) {
                        if (to.meta && to.meta.title) {
                          document.title = to.meta.title;
                        }
                        next();
                      });
                      _this4$vue = _this4.vue, h = _this4$vue.h, resolveComponent = _this4$vue.resolveComponent;
                      routerDetail = {
                        router: router,
                        render: _this4.vueVersion === 2 ? function (h) {
                          return h('router-view');
                        } : function () {
                          return h(resolveComponent('router-view'));
                        }
                      };
                    case 47:
                      mergedComponentDefinition = _objectSpread(_objectSpread({}, vueComponentDefDetail), routerDetail);
                      _context11.next = 50;
                      return _this4.getVuexStore();
                    case 50:
                      vuexStore = _context11.sent;
                      if (!(_this4.vueVersion === 3)) {
                        _context11.next = 57;
                        break;
                      }
                      _context11.next = 54;
                      return _this4.createAndMountApp(mergedComponentDefinition, vueModulePlaceholder, router);
                    case 54:
                      _context11.t2 = _context11.sent;
                      _context11.next = 58;
                      break;
                    case 57:
                      _context11.t2 = new _this4.vue(_objectSpread({
                        el: vueModulePlaceholder,
                        store: vuexStore
                      }, mergedComponentDefinition));
                    case 58:
                      module.module.vueComponent = _context11.t2;
                      if (_this4.spaParams.isSPA && !routerConfiguration) {
                        if (_this4.vuexStore) {
                          _this4.vuexStore.$router = _this4.routerInstance;
                        }
                        module.module.vueComponent.router = _this4.routerInstance;
                      }
                    case 60:
                    case "end":
                      return _context11.stop();
                  }
                }, _loop);
              });
              _iterator4.s();
            case 6:
              if ((_step4 = _iterator4.n()).done) {
                _context12.next = 10;
                break;
              }
              return _context12.delegateYield(_loop(), "t0", 8);
            case 8:
              _context12.next = 6;
              break;
            case 10:
              _context12.next = 15;
              break;
            case 12:
              _context12.prev = 12;
              _context12.t1 = _context12["catch"](3);
              _iterator4.e(_context12.t1);
            case 15:
              _context12.prev = 15;
              _iterator4.f();
              return _context12.finish(15);
            case 18:
            case "end":
              return _context12.stop();
          }
        }, _callee11, this, [[3, 12, 15, 18]]);
      }));
      function initModules() {
        return _initModules.apply(this, arguments);
      }
      return initModules;
    }())
  }, {
    key: "registerModuleClass",
    value: function registerModuleClass(_ref6) {
      var moduleClass = _ref6.moduleClass,
        moduleConfig = _ref6.moduleConfig;
      if (!this.modulesLoaded[moduleConfig.data.init]) {
        this.modulesLoaded[moduleConfig.data.init] = {
          moduleClass: moduleClass,
          moduleConfig: moduleConfig
        };
      }
    }

    /**
     * called by modules super
     * @param {object} module
     * @param {object} args
     * @param {string} init - name of function to be called in initModules
     */
  }, {
    key: "register",
    value: function register(module) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "init";
      this.modules.push({
        state: "ready",
        module: module,
        init: init,
        args: args
      });
    }

    /**
     * trigger throttled spartaWindowScroll event
     */
  }, {
    key: "setupGlobalEvents",
    value: function setupGlobalEvents(widgetInfo) {
      var _this5 = this;
      // Scroll
      window.addEventListener("scroll", _.throttle(function (e) {
        spartaEventsUtility.pub(_this5.EVENTS.SPARTA_WINDOW_SCROLL, [window.pageYOffset, e], widgetInfo);
      }, 20));
    }

    /**
     * run onloadHelpers for .spa-fn elements
     * @param {*} widgetInfo Object for the module widget
     * @returns {void}
     */
  }, {
    key: "onloadHelpers",
    value: function onloadHelpers(widgetInfo) {
      var _this6 = this;
      var containers = spartaStoreUtility.getData("applicationContainer", widgetInfo);
      var applicationContainer = Array.isArray(containers) ? containers[containers.length - 1] : containers;

      // Find all elements with a `spa-fn` class to run functions on
      var spaFnElems = this._getUninitializedModules(_toConsumableArray(applicationContainer.querySelectorAll('.spa-fn')));
      if (!spaFnElems.length) {
        return;
      }
      var onloadHelperRegister = ['.spa-boa-window', '.spa-mobile-tel'];
      onloadHelperRegister.forEach(function (helperClass) {
        if (helperClass === '.spa-mobile-tel' && !_this6.browser.mobile) {
          return;
        }
        var elsToProcess = _this6._getUninitializedModules(applicationContainer.querySelectorAll(".spa-fn".concat(helperClass)));
        if (elsToProcess.length) {
          switch (helperClass) {
            case '.spa-boa-window':
              spartaUILayersUtility.addPopupWindowHelper(elsToProcess);
              break;
            case '.spa-mobile-tel':
              spartaGlobalFunctions.mobilePhoneFormatHelper(elsToProcess);
              break;
          }
        }
      }, this);
    }

    /**
     * Helper fn that, given a list of modules, only returns uninitialized modules
     */
  }, {
    key: "_getUninitializedModules",
    value: function _getUninitializedModules(modules) {
      var _this7 = this;
      return _.filter(modules, function (module) {
        return !_.find(_this7.initedModules, function (initedModule) {
          return initedModule.module.settings.target === module;
        });
      });
    }
  }, {
    key: "initializeRouter",
    value: function initializeRouter(widgetInfo) {
      var _this8 = this;
      var spaAssetsHref = document.querySelector("[href*=spa-assets]").href;
      var spaMapUrl = "/".concat(spaAssetsHref.substring(0, spaAssetsHref.indexOf("/spa-assets/") + 12).replace(/^[a-zA-Z]{3,5}:\/{2}[a-zA-Z0-9_.:-]+\//, "")).concat(this.spaParams.spaFileName);
      return new Promise(function (resolve, reject) {
        spartaTransportUtility.subscribe({
          cache: true,
          dataType: "json",
          success: function success(data) {
            resolve(data);
          },
          error: function error() {
            // Still resolve so that we can use any
            // default data sources, if applicable.
            reject();
          },
          url: spaMapUrl
        });
      }).then(function (spaMap) {
        _this8.spaMap = spaMap;
        var altLanguageRoutes = _this8.getAltLanguageRoutes(spaMap.routes);
        spaMap.routes = [].concat(_toConsumableArray(spaMap.routes), _toConsumableArray(altLanguageRoutes));
        _this8.routeModulesContainer = _this8.routeModulesContainer || document.querySelector('#dynamic-row-body> .row > .column');
        var renderOptions = {
          style: {
            display: 'none'
          },
          domProps: {
            innerHTML: Math.random()
          }
        };
        var routeComponent = _this8.vueVersion === 2 ? (/*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(resolve, reject) {
            return _regeneratorRuntime.wrap(function _callee12$(_context13) {
              while (1) switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.prev = 0;
                  return _context13.abrupt("return", resolve({
                    render: function render(h) {
                      return h('div', renderOptions);
                    }
                  }));
                case 4:
                  _context13.prev = 4;
                  _context13.t0 = _context13["catch"](0);
                  return _context13.abrupt("return", reject(_context13.t0));
                case 7:
                case "end":
                  return _context13.stop();
              }
            }, _callee12, null, [[0, 4]]);
          }));
          return function (_x10, _x11) {
            return _ref7.apply(this, arguments);
          };
        }()) : function () {
          return new Promise(function (resolve, reject) {
            try {
              var h = _this8.vue.h;
              return resolve({
                render: function render() {
                  return h('div', renderOptions);
                }
              });
            } catch (error) {
              return reject(error);
            }
          });
        };
        var routes = _.map(spaMap.routes, function (route, i) {
          return {
            name: route.name,
            path: route.path,
            title: route.title,
            meta: {
              routeIndex: i
            },
            component: routeComponent
          };
        });
        _this8.routerInstance = _this8.vueVersion === 3 ? _this8.VueRouter.createRouter({
          routes: routes,
          history: _this8.VueRouter.createWebHistory()
        }) : new _this8.VueRouter({
          routes: routes,
          mode: 'history'
        });
        _this8.initedModules.forEach(function (module) {
          module.module.router = _this8.routerInstance;
        });
        var vueRoutePlaceholder = document.createElement("div");
        vueRoutePlaceholder.id = "routerVueInstanceContainer";
        document.body.appendChild(vueRoutePlaceholder);
        var self = _this8;
        // create dummy vue instance to react to route changes
        var routeComponentInfo = {
          el: vueRoutePlaceholder,
          router: _this8.routerInstance,
          render: self.vueVersion === 2 ? function (h) {
            return h('router-view');
          } : function () {
            return self.vue.h(self.vue.resolveComponent('router-view'));
          },
          watch: {
            $route: function $route(to, from) {
              try {
                if (from && to && from !== to && self.spaMap.routes[to.meta.routeIndex]) {
                  self.spaParams.pageParams = self.spaMap.routes[to.meta.routeIndex].pageDetails.pageParams;
                  self.clearRouteModules(self.spaMap.routes[from.meta.routeIndex]);
                  self.loadRouteModules(self.spaMap.routes[to.meta.routeIndex], widgetInfo);
                }
              } catch (error) {
                console.warn("Error for path ".concat(to.path, " at ").concat(error.stack, "."));
              }
            }
          }
        };
        if (_this8.vueVersion === 3) {
          _this8.createAndMountApp(routeComponentInfo, vueRoutePlaceholder);
        } else {
          new _this8.vue(routeComponentInfo);
        }
      });
    }
  }, {
    key: "getAltLanguageRoutes",
    value: function getAltLanguageRoutes(routes) {
      var altLangRoutes = [];
      _.each(routes, function (route) {
        route.language = "en";
        // check for languages other than English
        var altLanguages = _toConsumableArray(route.pageDetails.pageParams.languages.languages).filter(function (lang) {
          return lang !== "en";
        });
        if (altLanguages) {
          // create new route for each alternative language
          _.each(altLanguages, function (language) {
            altLangRoutes.push({
              path: "".concat(route.path.replace(/\/$/, ""), "/").concat(language),
              name: "".concat(route.name, "-").concat(language),
              pageDetails: route.pageDetails,
              modules: route.modules,
              language: language
            });
          });
        }
      });
      return altLangRoutes;
    }
  }, {
    key: "loadRouteModules",
    value: function () {
      var _loadRouteModules = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(route, widgetInfo) {
        var refModule;
        return _regeneratorRuntime.wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              this.spaParams.language = window.sparta.language = route.language;
              if (route.title) {
                document.title = route.title;
              }
              spartaStoreUtility.addData("spaParams", this.spaParams);
              spartaEventsUtility.pub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, this.spaParams);
              refModule = this.initedModules[0].module;
              _context14.next = 7;
              return refModule.mountAll(_.map(route.modules, function (mod) {
                return _objectSpread(_objectSpread({}, mod), {}, {
                  module: mod.name,
                  target: "#dynamic-row-body> .row > .column"
                });
              }));
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13, this);
      }));
      function loadRouteModules(_x12, _x13) {
        return _loadRouteModules.apply(this, arguments);
      }
      return loadRouteModules;
    }()
  }, {
    key: "clearRouteModules",
    value: function clearRouteModules(route) {
      var _this9 = this;
      var initedModules = [];
      var clearModule = true;
      this.initedModules.forEach(function (m) {
        clearModule = false;
        if (route) {
          route.modules.forEach(function (module) {
            if (module.name === m.module.settings.config.name) {
              clearModule = true;
            }
          });
        }
        if (!clearModule) {
          initedModules.push(m);
        } else {
          // if it is vue module then destroy the vue instance
          if (m.module.vueComponent) {
            if (_this9.vueVersion === 3) {
              m.module.vueComponent.unmount();
            } else {
              m.module.vueComponent.$destroy();
            }
          }
          // call modules destroy method
          if (m.module.destroy) {
            m.module.destroy();
          }
        }
      });
      this.initedModules = initedModules;
      //this.modulesLoaded = [];
      while (this.routeModulesContainer && this.routeModulesContainer.firstChild) {
        this.routeModulesContainer.removeChild(this.routeModulesContainer.firstChild);
      }
    }

    /**
     * Create and initialize modules
     */
  }, {
    key: "createAndInitModules",
    value: (function () {
      var _createAndInitModules = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(widgetInfo) {
        return _regeneratorRuntime.wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.createModuleInstances(widgetInfo);
            case 2:
              _context15.next = 4;
              return this.onloadHelpers(widgetInfo);
            case 4:
              _context15.next = 6;
              return this.initModules();
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee14, this);
      }));
      function createAndInitModules(_x14) {
        return _createAndInitModules.apply(this, arguments);
      }
      return createAndInitModules;
    }()
    /**
     * Initializes the CMS utility
     * Both site and page params can be set to enable/disable this utility
     */
    )
  }, {
    key: "initContentManagerUtility",
    value: function initContentManagerUtility(widgetInfo) {
      var getSpaParams = spartaStoreUtility.getData('spaParams');
      var autoRunCmsUtility = true;

      // Check site settings
      autoRunCmsUtility = 'autoRunCmsUtility' in getSpaParams.siteParams ? getSpaParams.siteParams.autoRunCmsUtility : autoRunCmsUtility;

      // Check page params
      autoRunCmsUtility = 'autoRunCmsUtility' in getSpaParams.pageParams ? getSpaParams.pageParams.autoRunCmsUtility : autoRunCmsUtility;
      if (autoRunCmsUtility) {
        spartaContentManagerUtility.init({
          widgetInfo: widgetInfo
        });
      }
    }

    /**
     * CSP: Add common click event listener to support the removal of 'javascript:void(0)' from links
     * @param {object} el - optional - element of on demand module so the entire dom is not targeted to add event listener when an element is passed
     */
  }, {
    key: "addPreventDefaultForLinks",
    value: function addPreventDefaultForLinks(el) {
      if (el instanceof Element || el instanceof Document) {
        var cspHelperLinks = _toConsumableArray(el.querySelectorAll('a.spa-prevent-default-click'));
        cspHelperLinks.forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
          });
        });
      }
    }

    /**
     * sets application data for storybook components
     * @returns {void}
     */
  }, {
    key: "setApplicationDataForStorybook",
    value: function setApplicationDataForStorybook(appContainer) {
      this.appContainer = appContainer;
      spartaMediaQueryUtility.init(this.appContainer);
      spartaStoreUtility.addData("applicationContainer", this.appContainer, true);
      spartaEventsUtility.pub(spartaEventsUtility.EVENTS.APP_CONTAINER_LOADED, this.appContainer);
    }

    /**
     * function to initialize storybook with required bootstrap logic
     * @returns {void}
     */
  }, {
    key: "initStorybook",
    value: function initStorybook(appContainer) {
      this.setupSpaParams();
      this.setApplicationDataForStorybook(appContainer);
      this.setupGlobalEvents();
      publishGlobalReadyEvents(this.loop, this.EVENTS);
    }
  }]);
}();
var index = new SpartaBootstrapUtility();
export { index as default };